// 250 MB max file size.
const MAX_FILE_SIZE_MB = 250 * 1024 * 1024;
export const MAX_FILESTACK_FILE_SIZE = MAX_FILE_SIZE_MB;
